import { configureStore } from "@reduxjs/toolkit";

import metricPlotSlice from "./metric-plots.js";
import fiaPortfolioSlice from "./fia-portfolio.js";
import auth0Slice from "./auth0.js";
import notificationsSlice from "./notifications.js";
import investorsSlice from "./investors.js";
import eventCorpSlice from "./event-corp.js";
const store = configureStore({
    reducer: {
        portfolios: fiaPortfolioSlice.reducer,
        metricPlots: metricPlotSlice.reducer,
        auth0: auth0Slice.reducer,
        notifications: notificationsSlice.reducer,
        investors: investorsSlice.reducer,
        eventCorp: eventCorpSlice.reducer,
    },
});

export default store;
